import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QrCodeModule } from 'ng-qrcode';

export type Restaurant = 'bella-vita' | 'chop-house';

@Component({
  selector: 'hh-restaurant-header-widget',
  standalone: true,
  imports: [CommonModule, QrCodeModule],
  templateUrl: './restaurant-header-widget.component.html',
  styleUrls: ['./restaurant-header-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestaurantHeaderWidgetComponent {
  @Input()
  public restaurant: Restaurant = 'bella-vita';

  private get backgroundImageName(): string {
    switch (this.restaurant) {
      case 'bella-vita':
        return 'bella-vita.png';

      case 'chop-house':
        return 'chop-house.png';
    }
  }

  private get backgroundImageUrl(): string {
    const basePath = 'assets/restaurants/backgrounds';

    return `${basePath}/${this.backgroundImageName}`;
  }

  private get logoImageName(): string {
    switch (this.restaurant) {
      case 'bella-vita':
        return 'bella-vita.png';

      case 'chop-house':
        return 'chop-house.png';
    }
  }

  protected get logoUrl(): string {
    const basePath = 'assets/restaurants/logos';

    return `${basePath}/${this.logoImageName}`;
  }

  protected get headerStyle(): Record<string, string> {
    return {
      'background-image': `url('${this.backgroundImageUrl}')`
    };
  }

  protected get reservationUrl(): string {
    switch (this.restaurant) {
      case 'bella-vita':
        return 'https://tables.toasttab.com/restaurants/1a64b2f6-9bac-4b46-a82b-a64ce95d4e69/reserve';

      case 'chop-house':
        return 'https://tables.toasttab.com/restaurants/294552cd-eca7-4792-9e2e-e17cb5bb815e/reserve';
    }
  }
}
